module.exports = __webpack_public_path__ + "media/images/indicators/alagamento-a27262ae6519e188d3b66cd6dc8b4e4d.png";